<template>
  <div>
    <ProceduresHeader class="mx-5 mt-8" @filterChange="filterChange" />
    <ProceduresInfoPanel class="mx-5 mt-10" :procedures="procedures" :filterActive="filter" />
    <ProceduresItemLists class="mx-5 mt-3" />
  </div>
</template>

<script>
import ProceduresHeader from "@/components/organisms/Procedimento/procedures-header";
import ProceduresInfoPanel from "@/components/organisms/Procedimento/procedures-info-panel";
import ProceduresItemLists from "@/components/organisms/Procedimento/procedures-item-lists";

export default {
  components: {
    ProceduresHeader,
    ProceduresInfoPanel,
    ProceduresItemLists
  },
  data() {
    return {
      procedures: [],
      filter: null
    };
  },
  methods: {
    filterChange(value) {
      this.filter = value;
    }
  },
  beforeMount() {
    this.procedures = this.$store.getters.procedures;
  }
};
</script>

<style scoped>
</style>